import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchCoursesSearchData } from "../../store/MyCourses-actions";

import { Controller, useForm } from "react-hook-form";

import moment from "moment";
import MomentUtils from "@date-io/moment";

import {
	DatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Styles from "./FormEnrolledFilter.module.css";

import "moment/locale/pt";
moment.locale("pt");

const FormEnrolledFilter = (props) => {
	const dispatch = useDispatch();
	const { handleSubmit, setValue, control } = useForm();

	const apiConfigData = useSelector((state) => state.apiConfigData);
	const CoursesSearchData = useSelector((state) => state.MyCoursesData.searchData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.myCoursesSearch;

	const resetForm = () => {
		console.log("resetForm");
		setValue("name", "");
		setValue("formatedDate", "");
		setValue("startDate", null);
		setValue("endDate", null);
		setValue("modalityId", "");
	};

	const onSubmit = (data) => {
		console.log(data);

		const refactorData = {...data, startDate: moment(data.startDate).toISOString(), endDate: moment(data.endDate).toISOString()}		
		console.log("refactorData", refactorData)
		
		props.filterData(refactorData);
	};

	// useEffect(() => {
	// 	// console.log("clear date")
	// 	setValue("startDate", null);
	// 	setValue("endDate", null);
	// }, [setValue]);

	useEffect(() => {
		setValue("startDate", null);
		setValue("endDate", null);
		dispatch(fetchCoursesSearchData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("CoursesSearchData", CoursesSearchData);
	}, [CoursesSearchData]);

	return (
		<form
			className={Styles["formEnrolledFilter"]}
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Nome
				</InputLabel>
				<Controller
					name="name"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-name"
							variant="outlined"
							autoComplete="off"
							type="text"
						/>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Data de Inicio
				</InputLabel>
				<Controller
					name="startDate"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<MuiPickersUtilsProvider utils={MomentUtils}>
							<DatePicker
								value={value}
								onChange={onChange}
												
								disableToolbar
								className={Styles["text-field"]}
								variant="inline"
								inputVariant="outlined"
								format="DD-MM-YYYY"
							/>
						</MuiPickersUtilsProvider>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Data de Fim
				</InputLabel>
				<Controller
					name="endDate"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<MuiPickersUtilsProvider utils={MomentUtils}>
							<DatePicker
								value={value}
								onChange={onChange}
												
								disableToolbar
								className={Styles["text-field"]}
								variant="inline"
								inputVariant="outlined"
								format="DD-MM-YYYY"
							/>
						</MuiPickersUtilsProvider>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Metodologia
				</InputLabel>
				<Controller
					name="modalityId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-modality"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{/* {enrolledMethodology.map((row) => ( */}
							{CoursesSearchData.modalities.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-3"}></div>
			<div className={"col-xs-3"}></div>
			<div className={"col-xs-3"}>
				<Button
					variant="contained"
					className={Styles["btn-filter"]}
					color="primary"
					disableElevation
					onClick={resetForm}
				>
					Limpar Dados
				</Button>
			</div>
			<div className={"col-xs-3"}>
				<Button
					type="submit"
					variant="contained"
					color="primary"
					className={Styles["btn-search"]}
					disableElevation
				>
					Pesquisar
				</Button>
			</div>
		</form>
	);
};

export default FormEnrolledFilter;
